if (!process.env.VUE_APP_IS_WEB) {
  var ResolutionVoteDB = require("../database/models/ResolutionVote");
  var MandateDB = require("../database/models/Mandate");
}

import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";

// ???: created, updated, deleted ??
export default {
  FETCH_BY_MANDATE(mandateId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionVoteDB()
          .query({ where: { mandate_id: mandateId, deleted: null } })
          .fetchAll()
          .then(res => {
            // console.log(res.serialize());
            ResolutionVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      // TODO:
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .FETCH_BY_MANDATE(mandateId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH(meetingResolutionId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionVoteDB()
          .query({ where: { meeting_has_resolution_id: meetingResolutionId, deleted: null } })
          .fetchAll()
          .then(res => {
            // console.log(res.serialize());
            ResolutionVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .FETCH(meetingResolutionId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionVoteDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            ResolutionVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item, save = true) {
    // permanet set the aagency id in desktop and web version
    item["agency_id"] = Number(localStorage.getItem("agencyId"));

    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new ResolutionVoteDB(itemPost)
          .save()
          .then(res => {
            if (save) {
              ResolutionVoteORM.insertOrUpdate({
                data: res.serialize(),
              });
            }
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item, save = true) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new ResolutionVoteDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            if (save) {
              ResolutionVoteORM.insertOrUpdate({
                data: res.serialize(),
              });
            }
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .PUT(item, save)
          .then(res => {
            // console.log("res", res);
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new ResolutionVoteDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            ResolutionVoteORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .DELETE(item)
          .then(res => {
            ResolutionVoteORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  async BULK_DELETE(items) {
    // console.log("BULK_DELETE", items);
    var errors = [];
    if (!process.env.VUE_APP_IS_WEB) {
      await Promise.all(
        items.map(async vote => {
          var itemDelete = JSON.parse(JSON.stringify(vote));
          await new ResolutionVoteDB(itemDelete)
            .save(null, { isDelete: true })
            .then(res => {
              ResolutionVoteORM.delete(itemDelete.id);
              return;
            })
            .catch(err => {
              console.error("err", err);
              error.push(err);
              return;
            });
        })
      );
      return;
    } else {
      // TODO: BULK DELETE ON API FOR RESOLUTION VOTES
      await ResolutionVoteORM.api()
        .BULK_DELETE({ items })
        .then(async res => {
          console.log("ResolutionVoteORM BULK_DELETE:", res);
          await items.map(async vote => {
            await ResolutionVoteORM.delete(vote.id);
          });
          return;
        })
        .catch(err => {
          console.error("error:", err);
          return;
        });
    }
  },
  async BULK_POST_PUT(existentVotes, inexistentVotes, voteType, presence_status) {
    if (!process.env.VUE_APP_IS_WEB) {
      var data = [];
      var errors = [];

      if (existentVotes.length > 0) {
        for (var voteId of existentVotes) {
          await new ResolutionVoteDB({ id: voteId })
            .save(
              {
                vote: voteType,
                presence_status: presence_status,
                agency_id: Number(localStorage.getItem("agencyId")),
              },
              {
                // ???: ..
                // method: "update",
                // patch: true,
                // require: false,
                isUpdate: true,
              }
            )
            .then(res => {
              data.push(res.serialize());
              return;
            })
            .catch(err => {
              errors.push(err);
            });
        }
      }

      if (inexistentVotes.length > 0) {
        for (var voteToCreate of inexistentVotes) {
          await new ResolutionVoteDB(voteToCreate)
            .save()
            .then(res => {
              data.push(res.serialize());
              return;
            })
            .catch(err => {
              errors.push(err);
              return;
            });
        }
      }
      ResolutionVoteORM.insertOrUpdate({
        data: data,
      });
      console.log("errors", errors);
      return;
    } else {
      if (existentVotes.length > 0) {
        let items = [];
        for (const resolutionVote of existentVotes) {
          items.push({
            id: resolutionVote.id,
            vote: resolutionVote.vote,
          });
        }
        await ResolutionVoteORM.api()
          .BULK_PUT({ items: items })
          .then(res => {
            console.log("ResolutionVoteORM.api().BULK_PUT res:", res);
          })
          .catch(err => {
            console.error("ResolutionVoteORM.api().BULK_PUT  err", err);
          });
      }
      if (inexistentVotes && inexistentVotes.length > 0) {
        console.log("{ items: items }", { items: inexistentVotes });
        await ResolutionVoteORM.api()
          .BULK_POST({ items: inexistentVotes })
          .then(res => {
            console.log("ResolutionVoteORM.api().BUILK_POST res:", res);
          })
          .catch(err => {
            console.error("ResolutionVoteORM.api().BUILK_POST  err", err);
          });
      }
    }
  },
  async BULK_VOTE(postObj) {
    if (!process.env.VUE_APP_IS_WEB) {
      var data = [];
      var errors = [];

      var mandates = [];
      await new MandateDB()
        .query(qb => {
          qb.whereIn("id", postObj.mandates_ids);
        })
        .fetchAll({ require: false })
        .then(res => {
          mandates = res.serialize() ? res.serialize() : [];
        });

      var existingVotes = [];
      await new ResolutionVoteDB()
        .query(qb => {
          qb.where("meeting_has_resolution_id", "=", postObj.meeting_resolution_id).whereNull(
            "deleted"
          );
        })
        .fetchAll({ require: false })
        .then(res => {
          existingVotes = res.serialize() ? res.serialize() : [];
        });

      for (var mandate of mandates) {
        var resolutionVote = false;
        for (var existingVote of existingVotes) {
          if (existingVote.mandate_id == mandate.id) {
            resolutionVote = existingVote;
          }
        }

        if (!resolutionVote) {
          // create new vote
          await new ResolutionVoteDB({
            meeting_has_resolution_id: postObj.meeting_resolution_id,
            mandate_id: mandate.id,
            vote: postObj.vote_type,
            presence_status: mandate.presence_status,
            agency_id: mandate.agency_id,
          })
            .save()
            .then(res => {
              data.push(res.serialize());
            })
            .catch(err => {
              errors.push(err);
            });
        } else {
          // update existing vote
          await new ResolutionVoteDB({ id: resolutionVote.id })
            .save(
              {
                vote: postObj.vote_type,
                presence_status: mandate.presence_status,
                agency_id: mandate.agency_id,
              },
              { isUpdate: true }
            )
            .then(res => {
              data.push(res.serialize());
            })
            .catch(err => {
              errors.push(err);
            });
        }
      }

      return new Promise((resolve, reject) => {
        if (errors.length == 0) {
          resolve({
            status: "success",
            message: "The process completed successfully.",
            data: data,
          });
        } else {
          reject({
            status: "error",
            message: "There were some errors in the process.",
            errors: errors,
          });
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .BULK_VOTE(postObj)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  RESET_IGNORED_CORRESPONDENCE(ignoredCorrespondenceVotes, meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: ..
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .RESET_IGNORED_CORRESPONDENCE(ignoredCorrespondenceVotes, meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_IGNORED_CORRESPONDENCE(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: ...
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .GET_IGNORED_CORRESPONDENCE(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_MEETING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: ...
    } else {
      return new Promise((resolve, reject) => {
        ResolutionVoteORM.api()
          .GET_BY_MEETING(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
